import { Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, record_type, option_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "./Context.js";
import { hierarchyContext } from "./CompanyHierarchyContext.js";
import { useResponsive } from "./Utils.js";
import { RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { loadingIndicatorLarge, SnackError } from "./ViewHelpers.js";
import { unwrap } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Components_CompanyHierarchySidebar_3A59D1F3 } from "./Components/CompanyHierarchySidebar.js";
import { tail, head, isEmpty, singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { join } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Typography } from "@mui/material";
import { Machine_View_41E5FE05 } from "./MachineView.js";
import { Customer } from "./CustomerView.js";
import { View as View_1 } from "./CustomerGroupView.js";
import { Route_$007CInt$007C_$007C } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";

class Model extends Record {
    constructor(ErrorMsg) {
        super();
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Home.Model", [], Model, () => [["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Home.Message", [], Message, () => [[]]);
}

function init() {
    return new Model(undefined);
}

function update(model, msg) {
    return new Model(undefined);
}

export function View(viewInputProps) {
    let elems_3;
    const key = viewInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const hierarchy = reactApi.useContext(hierarchyContext);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const responsive = useResponsive(undefined);
    const viewContainerRef = reactApi.useRef(undefined);
    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
    const xs_4 = [createElement(SnackError, {
        errMsg: unwrap(patternInput[0].ErrorMsg),
        dismiss: () => {
            patternInput[1](new Message());
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 15 + "px",
        height: 100 + "%",
    }], (elems_3 = toList(delay(() => {
        let matchValue, elems;
        return append((matchValue = responsive, (matchValue === "mobileLandscape") ? singleton(defaultOf()) : ((matchValue === "tablet") ? singleton(defaultOf()) : ((matchValue === "desktop") ? (!ctx.HideSidebar ? singleton(createElement("div", createObj(ofArray([["id", "company-hierarchy-sidebar-container"], ["style", {
            flexGrow: 1,
            flexShrink: 2,
            flexBasis: 320 + "px",
            minWidth: 300 + "px",
            maxWidth: 350 + "px",
        }], (elems = [createElement(Components_CompanyHierarchySidebar_3A59D1F3, {
            key: "company-hierarchy-sidebar",
            $key: "company-hierarchy-sidebar",
            onClose: () => {
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty()) : ((matchValue === "wideScreen") ? (!ctx.HideSidebar ? singleton(createElement("div", createObj(ofArray([["id", "company-hierarchy-sidebar-container"], ["style", {
            flexGrow: 1,
            flexShrink: 2,
            flexBasis: 320 + "px",
            minWidth: 300 + "px",
            maxWidth: 350 + "px",
        }], (elems = [createElement(Components_CompanyHierarchySidebar_3A59D1F3, {
            key: "company-hierarchy-sidebar",
            $key: "company-hierarchy-sidebar",
            onClose: () => {
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty()) : singleton(defaultOf()))))), delay(() => {
            let elems_2;
            return singleton(createElement("div", createObj(ofArray([["id", "home-view-container"], ["ref", viewContainerRef], ["className", join(" ", ["home-main-container"])], (elems_2 = toList(delay(() => {
                let elems_1;
                if (!hierarchy.GroupsFetched) {
                    return singleton(loadingIndicatorLarge());
                }
                else {
                    const matchValue_1 = currentUrl;
                    let matchResult, customerId, groupId, id, rest;
                    if (!isEmpty(matchValue_1)) {
                        if (head(matchValue_1) === "group") {
                            if (!isEmpty(tail(matchValue_1))) {
                                const activePatternResult = Route_$007CInt$007C_$007C(head(tail(matchValue_1)));
                                if (activePatternResult != null) {
                                    if (!isEmpty(tail(tail(matchValue_1)))) {
                                        if (head(tail(tail(matchValue_1))) === "customer") {
                                            if (!isEmpty(tail(tail(tail(matchValue_1))))) {
                                                const activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(tail(tail(matchValue_1)))));
                                                if (activePatternResult_1 != null) {
                                                    if (!isEmpty(tail(tail(tail(tail(matchValue_1)))))) {
                                                        if (head(tail(tail(tail(tail(matchValue_1))))) === "machine") {
                                                            if (!isEmpty(tail(tail(tail(tail(tail(matchValue_1))))))) {
                                                                const activePatternResult_2 = Route_$007CInt$007C_$007C(head(tail(tail(tail(tail(tail(matchValue_1)))))));
                                                                if (activePatternResult_2 != null) {
                                                                    matchResult = 1;
                                                                    customerId = activePatternResult_1;
                                                                    groupId = activePatternResult;
                                                                    id = activePatternResult_2;
                                                                    rest = tail(tail(tail(tail(tail(tail(matchValue_1))))));
                                                                }
                                                                else {
                                                                    matchResult = 2;
                                                                }
                                                            }
                                                            else {
                                                                matchResult = 2;
                                                            }
                                                        }
                                                        else {
                                                            matchResult = 2;
                                                        }
                                                    }
                                                    else {
                                                        matchResult = 2;
                                                    }
                                                }
                                                else {
                                                    matchResult = 2;
                                                }
                                            }
                                            else {
                                                matchResult = 2;
                                            }
                                        }
                                        else {
                                            matchResult = 2;
                                        }
                                    }
                                    else {
                                        matchResult = 2;
                                    }
                                }
                                else {
                                    matchResult = 2;
                                }
                            }
                            else {
                                matchResult = 2;
                            }
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else {
                        matchResult = 0;
                    }
                    switch (matchResult) {
                        case 0:
                            return (hierarchy.Groups.length === 0) ? singleton(createElement("div", createObj(singleton_1((elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("MissingAccess")]]), MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("ContactForAccess")]])], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))) : singleton(loadingIndicatorLarge());
                        case 1:
                            return singleton(createElement(Machine_View_41E5FE05, {
                                machineId: id,
                                customerId: customerId,
                                groupId: groupId,
                                path: rest,
                            }));
                        default: {
                            let matchResult_1, customerId_1, groupId_1, rest_1;
                            if (!isEmpty(matchValue_1)) {
                                if (head(matchValue_1) === "group") {
                                    if (!isEmpty(tail(matchValue_1))) {
                                        const activePatternResult_3 = Route_$007CInt$007C_$007C(head(tail(matchValue_1)));
                                        if (activePatternResult_3 != null) {
                                            if (!isEmpty(tail(tail(matchValue_1)))) {
                                                if (head(tail(tail(matchValue_1))) === "customer") {
                                                    if (!isEmpty(tail(tail(tail(matchValue_1))))) {
                                                        const activePatternResult_4 = Route_$007CInt$007C_$007C(head(tail(tail(tail(matchValue_1)))));
                                                        if (activePatternResult_4 != null) {
                                                            matchResult_1 = 0;
                                                            customerId_1 = activePatternResult_4;
                                                            groupId_1 = activePatternResult_3;
                                                            rest_1 = tail(tail(tail(tail(matchValue_1))));
                                                        }
                                                        else {
                                                            matchResult_1 = 1;
                                                        }
                                                    }
                                                    else {
                                                        matchResult_1 = 1;
                                                    }
                                                }
                                                else {
                                                    matchResult_1 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_1 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_1 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                            switch (matchResult_1) {
                                case 0:
                                    return singleton(createElement(Customer, {
                                        path: rest_1,
                                        groupId: groupId_1,
                                        customerId: customerId_1,
                                    }));
                                default: {
                                    let matchResult_2, groupId_2, rest_2;
                                    if (!isEmpty(matchValue_1)) {
                                        if (head(matchValue_1) === "group") {
                                            if (!isEmpty(tail(matchValue_1))) {
                                                const activePatternResult_5 = Route_$007CInt$007C_$007C(head(tail(matchValue_1)));
                                                if (activePatternResult_5 != null) {
                                                    matchResult_2 = 0;
                                                    groupId_2 = activePatternResult_5;
                                                    rest_2 = tail(tail(matchValue_1));
                                                }
                                                else {
                                                    matchResult_2 = 1;
                                                }
                                            }
                                            else {
                                                matchResult_2 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_2 = 1;
                                    }
                                    switch (matchResult_2) {
                                        case 0:
                                            return singleton(createElement(View_1, {
                                                groupId: groupId_2,
                                                path: rest_2,
                                            }));
                                        default:
                                            return singleton(createElement("p", {
                                                children: ["404"],
                                            }));
                                    }
                                }
                            }
                        }
                    }
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

export default ((key) => createElement(View, {
    key: key,
    $key: key,
}));

